<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="37"
        height="37"
        viewBox="0 0 37 37"
        fill="none"
    >
        <g filter="url(#filter0_ii_1282_6089)">
            <path
                d="M19.9582 0C21.7174 -3.07592e-07 23.1041 1.44717 23.5213 3.1562C24.6907 7.94848 28.4633 11.7211 33.2556 12.8905C34.4993 13.194 35.6016 14.0122 36.1111 15.1126C36.2145 15.3325 36.2956 15.5662 36.3461 15.8118C36.3891 16.0191 36.4118 16.2335 36.4118 16.4536V20.0168C36.4117 20.4864 36.3054 20.9321 36.1223 21.3313C35.6183 22.445 34.5092 23.274 33.2556 23.5799C28.4633 24.7493 24.6907 28.5219 23.5213 33.3142C23.1042 35.0234 21.7175 36.4704 19.9582 36.4704H16.3964C14.6371 36.4704 13.1876 35.0363 13.4262 33.2932C14.2603 27.2023 17.4585 21.8647 22.0656 18.2352C17.4586 14.6057 14.2603 9.26809 13.4262 3.17718C13.1878 1.43426 14.6372 3.07595e-07 16.3964 0H19.9582Z"
                fill="url(#paint0_linear_1282_6089)"
            />
        </g>
        <foreignObject
            x="-3.39744"
            y="-3.39744"
            width="29.8061"
            height="43.2656"
            ><div
                xmlns="http://www.w3.org/1999/xhtml"
                style="
                    backdrop-filter: blur(1.7px);
                    clip-path: url(#bgblur_0_1282_6089_clip_path);
                    height: 100%;
                    width: 100%;
                "
            ></div
        ></foreignObject>
        <g
            filter="url(#filter1_ii_1282_6089)"
            data-figma-bg-blur-radius="3.39744"
        >
            <path
                d="M16.4535 0C14.6942 -3.07592e-07 13.3075 1.44717 12.8903 3.1562C11.7209 7.94848 7.9483 11.7211 3.15603 12.8905C1.91233 13.194 0.810041 14.0122 0.300482 15.1126C0.197104 15.3325 0.11599 15.5662 0.0655479 15.8118C0.0225296 16.0191 -0.000160217 16.2335 -0.000175476 16.4536V20.0168C-0.000116348 20.4864 0.10626 20.9321 0.289295 21.3313C0.793278 22.445 1.90239 23.274 3.15603 23.5799C7.9483 24.7493 11.7209 28.5219 12.8903 33.3142C13.3074 35.0234 14.6941 36.4704 16.4535 36.4704H20.0152C21.7746 36.4704 23.2241 35.0363 22.9854 33.2932C22.1513 27.2023 18.9531 21.8647 14.3461 18.2352C18.953 14.6057 22.1513 9.26809 22.9854 3.17718C23.2238 1.43426 21.7744 3.07595e-07 20.0152 0H16.4535Z"
                fill="url(#paint1_linear_1282_6089)"
                fill-opacity="0.6"
            />
        </g>
        <defs>
            <filter
                id="filter0_ii_1282_6089"
                x="13.4004"
                y="0"
                width="23.2779"
                height="37.4707"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="BackgroundImageFix"
                    result="shape"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="0.266667" dy="1" />
                <feGaussianBlur stdDeviation="1.33333" />
                <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
                />
                <feBlend
                    mode="normal"
                    in2="shape"
                    result="effect1_innerShadow_1282_6089"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="0.0666667" dy="0.16" />
                <feGaussianBlur stdDeviation="0.0333333" />
                <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.65 0"
                />
                <feBlend
                    mode="normal"
                    in2="effect1_innerShadow_1282_6089"
                    result="effect2_innerShadow_1282_6089"
                />
            </filter>
            <filter
                id="filter1_ii_1282_6089"
                x="-3.39744"
                y="-3.39744"
                width="29.8061"
                height="43.2656"
                filterUnits="userSpaceOnUse"
                color-interpolation-filters="sRGB"
            >
                <feFlood flood-opacity="0" result="BackgroundImageFix" />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="BackgroundImageFix"
                    result="shape"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="0.266667" dy="1" />
                <feGaussianBlur stdDeviation="1.33333" />
                <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.4 0"
                />
                <feBlend
                    mode="normal"
                    in2="shape"
                    result="effect1_innerShadow_1282_6089"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                    result="hardAlpha"
                />
                <feOffset dx="0.0666667" dy="0.16" />
                <feGaussianBlur stdDeviation="0.0333333" />
                <feComposite
                    in2="hardAlpha"
                    operator="arithmetic"
                    k2="-1"
                    k3="1"
                />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.65 0"
                />
                <feBlend
                    mode="normal"
                    in2="effect1_innerShadow_1282_6089"
                    result="effect2_innerShadow_1282_6089"
                />
            </filter>
            <clipPath
                id="bgblur_0_1282_6089_clip_path"
                transform="translate(3.39744 3.39744)"
            >
                <path
                    d="M16.4535 0C14.6942 -3.07592e-07 13.3075 1.44717 12.8903 3.1562C11.7209 7.94848 7.9483 11.7211 3.15603 12.8905C1.91233 13.194 0.810041 14.0122 0.300482 15.1126C0.197104 15.3325 0.11599 15.5662 0.0655479 15.8118C0.0225296 16.0191 -0.000160217 16.2335 -0.000175476 16.4536V20.0168C-0.000116348 20.4864 0.10626 20.9321 0.289295 21.3313C0.793278 22.445 1.90239 23.274 3.15603 23.5799C7.9483 24.7493 11.7209 28.5219 12.8903 33.3142C13.3074 35.0234 14.6941 36.4704 16.4535 36.4704H20.0152C21.7746 36.4704 23.2241 35.0363 22.9854 33.2932C22.1513 27.2023 18.9531 21.8647 14.3461 18.2352C18.953 14.6057 22.1513 9.26809 22.9854 3.17718C23.2238 1.43426 21.7744 3.07595e-07 20.0152 0H16.4535Z"
                />
            </clipPath>
            <linearGradient
                id="paint0_linear_1282_6089"
                x1="36.4118"
                y1="29.4419"
                x2="5.27523"
                y2="9.61679"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#982000" />
                <stop offset="0.471154" stop-color="#E55A00" />
                <stop offset="1" stop-color="#FFB350" />
            </linearGradient>
            <linearGradient
                id="paint1_linear_1282_6089"
                x1="-10.9234"
                y1="36.4704"
                x2="26.5603"
                y2="18.5025"
                gradientUnits="userSpaceOnUse"
            >
                <stop stop-color="#721800" />
                <stop offset="0.471154" stop-color="#E55A00" />
                <stop offset="1" stop-color="#FFB350" />
            </linearGradient>
        </defs>
    </svg>
</template>
